<script lang="ts" setup>
import { useRouter } from 'vue-router';

import Logo from '@exchange/assets/one-trading-white-logo.svg';

const router = useRouter();

const goHome = () => {
  router.push({ name: 'exchange' });
};
</script>

<template>
  <div class="login-error">
    <header class="login-error__header">
      <logo class="login-error__logo" />
    </header>
    <div class="login-error__content">
      <h1 class="login-error__title">{{ $t('views.loginError.title') }}</h1>
      <p class="login-error__text">
        {{ $t('views.loginError.text') }}
        <x-button
          class="login-error__link"
          variant="link"
          size="text-like"
          @click="goHome"
        >
          {{ $t('views.loginError.link') }}
        </x-button>
      </p>
    </div>
  </div>
</template>

<style lang="scss">
.login-error {
  padding: 17px;

  &__header {
    display: flex;
    width: 170px;
    height: 17px;
    align-items: center;
    justify-content: center;
  }

  &__content {
    max-width: 320px;
    margin: 5vh auto;
    color: rgb(var(--v-theme-text-primary));
    letter-spacing: 0.26px;

    .xs & {
      width: auto;
      margin: 0;
    }
  }

  &__title {
    margin: 28px 0 5px;
    font-size: var(--font-size-md);
    font-weight: 500;
  }

  &__text {
    margin: 0;
    font-size: var(--font-size-sm);
    white-space: pre-wrap;
  }

  &__link {
    color: inherit;
  }
}
</style>
